import { Request,BaseApiUrl } from "./api";
// 工作流历史模块
// 列表
export const getApprovalRecordList = (params) => {
  return Request.get(`${BaseApiUrl}/api/ApprovalRecord/get`, { params: params });
};
//新增
export const addApprovalRecord = (params) => {
  return Request.post(`${BaseApiUrl}/api/ApprovalRecord/post`, params);
};

// export const batchDeleteApprovalRecord = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ApprovalRecord/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };